var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useBreadCrumbs)?_c('v-breadcrumbs',{attrs:{"divider":">","items":this.breadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{attrs:{"to":item.to,"exact":item.exact,"disabled":item.disabled}},[_c('span',[_vm._v(_vm._s(_vm.$t(item.text)))])])]}}],null,false,1972842333)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }